<div class="mobile-nav-bar">
    <!-- Logo Section -->
    <div class="flex items-center flex-shrink-0">
        <a routerLink="/mission-control">
             <svg class="nav-logo pr-2" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 2715 649.75">
               <style type="text/css">
                   .st0{fill:#FFFFFF;}
                   .st1{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}
                   .st2{fill:#55C1AC;}
                   .st3{opacity:0.86;}
               </style>
               <g>
                 <path class="st0" d="M224.81,459.75L291.93,14.94h136.94v626.5h-93.08V192.15l-68.02,449.29h-93.08L101.3,198.41v443.03H15.38V14.94h136.94l72.5,444.82Z"/>
                 <path class="st0" d="M479.87,14.94h98.45v626.5h-98.45V14.94Z"/>
                 <path class="st0" d="M761.78,7.78c95.77,0,144.99,57.28,144.99,157.52v19.69h-93.08v-25.96c0-44.75-17.9-61.76-49.22-61.76s-49.23,17-49.23,61.76c0,128.88,192.43,153.05,192.43,332.05,0,100.24-50.12,157.52-146.78,157.52s-146.78-57.28-146.78-157.52v-38.48h93.08v44.75c0,44.75,19.69,60.86,51.01,60.86s51.02-16.11,51.02-60.86c0-128.88-192.43-153.05-192.43-332.05,0-100.24,49.22-157.52,144.99-157.52Z"/>
                 <path class="st0" d="M1075.92,7.78c95.77,0,144.99,57.28,144.99,157.52v19.69h-93.08v-25.96c0-44.75-17.9-61.76-49.22-61.76s-49.23,17-49.23,61.76c0,128.88,192.43,153.05,192.43,332.05,0,100.24-50.12,157.52-146.78,157.52s-146.78-57.28-146.78-157.52v-38.48h93.08v44.75c0,44.75,19.69,60.86,51.01,60.86s51.02-16.11,51.02-60.86c0-128.88-192.43-153.05-192.43-332.05,0-100.24,49.22-157.52,144.99-157.52Z"/>
                 <path class="st0" d="M1257.6,14.94h98.45v626.5h-98.45V14.94Z"/>
                 <path class="st0" d="M1399,165.3c0-100.24,52.81-157.52,149.47-157.52s149.47,57.28,149.47,157.52v325.78c0,100.24-52.81,157.52-149.47,157.52s-149.47-57.28-149.47-157.52V165.3ZM1497.45,497.34c0,44.75,19.69,61.76,51.02,61.76s51.02-17.01,51.02-61.76V159.03c0-44.75-19.69-61.76-51.02-61.76s-51.02,17-51.02,61.76v338.31Z"/>
                 <path class="st0" d="M1828.59,187.67v453.77h-88.61V14.94h123.51l101.13,375.01V14.94h87.71v626.5h-101.14l-122.62-453.77Z"/>
               </g>
               <path class="st0" d="M2649.21,6.38h-522.82c-31.95,0-58.09,26.14-58.09,58.09v522.82c0,31.95,26.14,58.09,58.09,58.09h522.82c31.95,0,58.09-26.14,58.09-58.09V64.47c0-31.95-26.14-58.09-58.09-58.09ZM2165.08,191.51c3.04,7.21,7.24,13.45,12.61,18.73,5.36,5.28,11.69,9.37,18.97,12.25,7.28,2.88,15.33,4.32,24.14,4.32s16.73-1.64,24.26-4.92c7.52-3.28,14.41-8.29,20.65-15.01l20.17,18.97c-7.85,9.29-17.45,16.33-28.82,21.13-11.37,4.8-24.02,7.21-37.95,7.21-12.97,0-24.9-2.12-35.78-6.36-10.89-4.24-20.38-10.29-28.46-18.13-8.09-7.84-14.37-16.97-18.85-27.38-4.48-10.41-6.72-21.93-6.72-34.58s2.24-24.17,6.72-34.58c4.48-10.41,10.81-19.53,18.97-27.38,8.17-7.84,17.69-13.89,28.58-18.13,10.89-4.24,22.82-6.36,35.78-6.36,13.77,0,26.34,2.36,37.71,7.08,11.37,4.72,20.97,11.73,28.82,21.01l-20.17,18.97c-6.24-6.56-13.13-11.49-20.65-14.77-7.53-3.28-15.61-4.92-24.26-4.92s-16.85,1.44-24.14,4.32c-7.29,2.88-13.61,6.96-18.97,12.25-5.37,5.28-9.57,11.53-12.61,18.73-3.04,7.21-4.56,15.13-4.56,23.78s1.52,16.57,4.56,23.78ZM2376.91,251.31c-5.13,1.44-10.33,2.16-15.61,2.16-14.09,0-24.98-3.64-32.66-10.93-7.68-7.28-11.53-17.97-11.53-32.06v-61.96h-21.13v-24.02h21.13v-29.3h29.78v29.3h34.58v24.02h-34.58v61c0,6.09,1.6,10.81,4.8,14.17,3.2,3.36,7.68,5.04,13.45,5.04,6.56,0,12.01-1.76,16.33-5.28l8.65,21.37c-3.68,2.88-8.09,5.04-13.21,6.48ZM2488.82,150.44c-1.12-.16-2.24-.28-3.36-.36-1.12-.08-2.16-.12-3.12-.12-11.53,0-20.65,3.28-27.38,9.85-6.72,6.57-10.09,16.57-10.09,30.02v61.96h-29.78V123.54h28.58v18.64c3.62-5.6,8.49-10.1,14.65-13.47,8.32-4.56,18.49-6.84,30.5-6.84v28.58ZM2545.74,251.79h-29.78V73.59h29.78v178.2Z"/>
             </svg>
        </a>
    </div>

    <!-- Right Side Actions -->
    <div class="flex items-center">
        <!-- Menu Toggle Button -->
        <button class="p-2 rounded-lg hover:bg-gray-100 transition-colors" (click)="toggleMobileNav()">
            <fa-icon [icon]="showMobileNav ? icons.solid.faXmark : icons.solid.faBars" style="color: white;"></fa-icon>
        </button>
    </div>
</div>

<!-- Mobile Navigation Menu -->
<div *ngIf="showMobileNav" class="mobile-nav-menu bg-surface-50 dark:bg-surface-950">
    <!-- Header with close button -->
    <div class="flex items-center justify-between p-4 border-b" style="border-color: var(--p-surface-border);">
        <h2 class="text-lg font-semibold" style="color: var(--p-text-color);">Menu</h2>
        <button class="p-2 rounded-lg transition-colors" 
                style="background-color: transparent; color: var(--p-text-color);"
                (mouseenter)="onMouseEnterTransparent($event)"
                (mouseleave)="onMouseLeaveTransparent($event)"
                (click)="toggleMobileNav()">
            <fa-icon [icon]="icons.solid.faXmark" style="color: var(--p-text-color);"></fa-icon>
        </button>
    </div>


    <!-- Navigation Layout -->
    <div class="flex flex-1 overflow-hidden">
        <!-- Column 1 - Main Navigation -->
        <div class="w-28 flex-shrink-0 border-r overflow-y-auto bg-surface-50 dark:bg-surface-950" 
             style="border-color: var(--p-surface-border); ">
            <div class="h-full flex flex-col">
                <!-- Search Item -->
                <div class="mobile-nav-button cursor-pointer"
                     [ngClass]="showMobileSearch ? 'bg-primary-100 dark:bg-primary-800 border-2 border-primary-300' : ''" 
                     (click)="toggleMobileSearch()"
                     [title]="'Search'">
                    <fa-icon [icon]="icons.solid.faMagnifyingGlass" style="color: var(--p-text-color);"></fa-icon>
                    <span style="color: var(--p-text-color);">Search</span>
                </div>
                
                <!-- Regular Navigation Items -->
                <div *ngFor="let navItem of navItems" 
                     class="mobile-nav-button cursor-pointer"
                     [ngClass]="navItem === activeNavItem ? 'bg-primary-100 dark:bg-primary-800 border-2 border-primary-300' : ''" 
                     (click)="setActiveNavItem(navItem)"
                     (contextmenu)="onNavItemRightClick($event, navItem)"
                     [title]="navItem.label">
                    <fa-icon *ngIf="navItem.icon" [icon]="navItem.icon" style="color: var(--p-text-color);"></fa-icon>
                    <span style="color: var(--p-text-color);">{{navItem.label}}</span>
                </div>
                
                <!-- Account Menu Item -->
                <div class="mobile-nav-button cursor-pointer"
                     [ngClass]="showAccountMenu ? 'bg-primary-100 dark:bg-primary-800 border-2 border-primary-300' : ''" 
                     (click)="handleAccountClick($event)"
                     [title]="'Account'">
                    <!-- User Photo (if available) -->
                    <img *ngIf="showUserPhoto && userPhotoUrl" 
                         [src]="userPhotoUrl" 
                         [alt]="username"
                         class="w-10 h-10 rounded-full object-cover border border-gray-300 dark:border-gray-700"
                         (error)="showUserPhoto = false; cdr.detectChanges()">
                    
                    <!-- Fallback Avatar (first letter) -->
                    <div *ngIf="!showUserPhoto && (auth.currentUser$ | async)" 
                         class="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg">
                        {{username[0]}}
                    </div>
                    
                    <span style="color: var(--p-text-color);">ACCOUNT</span>
                </div>
                
                <!-- Theme Picker Item -->
                <div *ngIf="themeItem" class="mobile-nav-button cursor-pointer"
                     [ngClass]="showThemePicker ? 'bg-primary-100 dark:bg-primary-800 border-2 border-primary-300' : ''" 
                     (click)="handleThemeClick($event)"
                     [title]="'Theme'">
                    <fa-icon [icon]="icons.regular.faPalette" style="color: var(--p-text-color);"></fa-icon>
                    <span style="color: var(--p-text-color);">THEME</span>
                </div>
            </div>
        </div>

         <!-- Column 2 - All Content -->
         <div class="flex-1 flex flex-col min-w-0 overflow-hidden">
             <!-- Search Content -->
             <div *ngIf="showMobileSearch" class="flex flex-col h-full">
                <!-- Search Input - Fixed at top -->
                <div class="p-4 pb-0">
                    <div class="search-input-container-mobile mb-4">
                        <input 
                            type="text"
                            placeholder="Search..." 
                            class="search-input-mobile"
                            [(ngModel)]="searchValue"
                            (input)="onSearchInputChange($event)"
                            (keyup.enter)="onSearchEnterKeyPress()">
                        <button 
                            type="button" 
                            class="search-button-mobile"
                            (click)="onSearchButtonClick()">
                            <fa-icon [icon]="icons.solid.faMagnifyingGlass"></fa-icon>
                        </button>
                    </div>
                </div>
                
                <!-- Search Results Container - Scrollable -->
                <div class="flex-1 overflow-y-auto px-3 pb-3 min-w-0">
                    <!-- Search Loading -->
                    <div *ngIf="isSearchLoading" class="text-center py-4">
                        <p-progressSpinner [style]="{'width': '20px', 'height': '20px'}" strokeWidth="3"></p-progressSpinner>
                        <span class="ml-2">Searching...</span>
                    </div>
                    
                    <!-- Search Error -->
                    <div *ngIf="searchError" class="text-center py-4 text-red-600">
                        {{searchError}}
                    </div>
                    
                    <!-- Search Results with Virtual Scroll -->
                    <div *ngIf="searchResults && searchResults.length > 0" class="w-full">
                        <!-- CSV Export Button -->
                        <div class="flex justify-end mb-3 px-3">
                            <button 
                                class="flex items-center gap-2 px-3 py-2 text-sm bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
                                (click)="exportSearchResultsToCSV()"
                                title="Export search results to CSV">
                                <fa-icon [icon]="icons.ppmSolid.download" class="text-sm"></fa-icon>
                                <span>Export CSV</span>
                            </button>
                        </div>
                        
                        <div class="space-y-1 w-full">
                            <div *ngFor="let result of searchResults; trackBy: getResultCardId; let i = index" 
                                 class="search-result-card cursor-pointer w-full mb-2"
                                 [class.expanded]="isResultCardExpanded(result, i)"
                                 [class.collapsed]="!isResultCardExpanded(result, i)"
                                 (mouseenter)="onMouseEnter($event)"
                                 (mouseleave)="onMouseLeave($event)"
                                 (click)="toggleResultCard(result, i)">
                                
                                <!-- Card Header (Always Visible) -->
                                <div class="card-header">
                                    <div class="flex items-center justify-between px-3 py-2 w-full">
                                        <div class="flex flex-col gap-1 flex-1 min-w-0">
                                            <div class="card-title text-base font-semibold break-words" style="color: var(--p-text-color);">
                                                {{result.name}}
                                            </div>
                                            <p-chip [label]="result.type" 
                                                   [styleClass]="getTypeChipClass(result.type)"
                                                   styleClass="text-xs w-fit"></p-chip>
                                        </div>
                                        <fa-icon [icon]="icons.solid.faChevronDown" 
                                                 class="text-sm transition-transform duration-200 flex-shrink-0 ml-2"
                                                 [class.mobile-chevron-rotate]="isResultCardExpanded(result, i)"></fa-icon>
                                    </div>
                                </div>
                                
                                <!-- Card Content (Only when expanded) -->
                                <div *ngIf="isResultCardExpanded(result, i)" class="card-content">
                                    <!-- Comprehensive Info Grid - Matching ColdFusion Results -->
                                    <div class="space-y-3 w-full">
                                        <!-- Group ID -->
                                        <div *ngIf="result.groupId" class="w-full">
                                            <div class="text-xs font-medium mb-1" style="color: var(--p-text-color-secondary);">Group ID</div>
                                            <div class="text-sm font-mono break-words" style="color: var(--p-text-color);">{{result.groupId}}</div>
                                        </div>
                                        
                                        
                                        <!-- Company/Group Name -->
                                        <div *ngIf="result.company" class="w-full">
                                            <div class="text-xs font-medium mb-1" style="color: var(--p-text-color-secondary);">Company</div>
                                            <div class="text-sm break-words" style="color: var(--p-text-color);">{{result.company}}</div>
                                        </div>
                                        
                                        <!-- Phone 1 -->
                                        <div *ngIf="result.phone1" class="w-full">
                                            <div class="text-xs font-medium mb-1" style="color: var(--p-text-color-secondary);">Phone 1</div>
                                            <a [href]="'tel:' + result.phone1" 
                                               class="text-sm text-primary-600 hover:text-primary-800 transition-colors break-words block">
                                                {{result.phone1}}
                                            </a>
                                        </div>
                                        
                                        <!-- Phone 2 -->
                                        <div *ngIf="result.phone2" class="w-full">
                                            <div class="text-xs font-medium mb-1" style="color: var(--p-text-color-secondary);">Phone 2</div>
                                            <a [href]="'tel:' + result.phone2" 
                                               class="text-sm text-primary-600 hover:text-primary-800 transition-colors break-words block">
                                                {{result.phone2}}
                                            </a>
                                        </div>
                                        
                                        <!-- Email -->
                                        <div *ngIf="result.email" class="w-full">
                                            <div class="text-xs font-medium mb-1" style="color: var(--p-text-color-secondary);">Email</div>
                                            <a [href]="'mailto:' + result.email" 
                                               class="text-sm text-primary-600 hover:text-primary-800 transition-colors break-words block">
                                                {{result.email}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Card Footer (Action Buttons) -->
                                <div *ngIf="isResultCardExpanded(result, i)" class="card-footer">
                                    <div class="flex flex-col gap-2">
                                        <!-- Action Buttons Row -->
                                        <div class="flex gap-2">
                                            <p-button 
                                                icon="pi pi-comment" 
                                                size="small"
                                                styleClass="flex-1 p-button-outlined"
                                                [title]="'Log Activity'"
                                                (click)="openLogActivity(result); $event.stopPropagation()">
                                            </p-button>
                                            <p-button 
                                                icon="pi pi-calendar" 
                                                size="small"
                                                styleClass="flex-1 p-button-outlined"
                                                [title]="'Schedule Activity'"
                                                (click)="openScheduleActivity(result); $event.stopPropagation()">
                                            </p-button>
                                        </div>
                                        
                                        <!-- View Details Button -->
                                        <ng-container *ngIf="result.type === 'Trip'; else contactCardLink">
                                            <p-button [label]="'View Trip'"
                                                      icon="pi pi-external-link"
                                                      styleClass="w-full"
                                                      size="small"
                                                      (click)="onSearchResultClick(result); $event.stopPropagation()">
                                            </p-button>
                                        </ng-container>
                                        
                                        <ng-template #contactCardLink>
                                            <a [href]="result.groupId | contactCardUrl" 
                                               target="_blank"
                                               class="w-full">
                                                <p-button [label]="'View Contact Card'"
                                                          icon="pi pi-external-link"
                                                          styleClass="w-full"
                                                          size="small"
                                                          (click)="$event.stopPropagation()">
                                                </p-button>
                                            </a>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- No Results -->
                    <div *ngIf="hasSearched && !isSearchLoading && (!searchResults || searchResults.length === 0) && !searchError" 
                         class="text-center py-8" style="color: var(--p-text-color-secondary);">
                        No results found for "{{searchValue}}"
                    </div>
                </div>
             </div>

             <!-- Account Menu Content -->
             <div *ngIf="showAccountMenu && !showMobileSearch" class="flex-1 overflow-y-auto p-4 space-y-4">
                    <!-- User Info Section -->
                    <div class="flex items-center space-x-3 p-4 rounded-lg bg-surface-50 dark:bg-surface-950" >
                        <!-- User Photo (if available) -->
                        <img *ngIf="showUserPhoto && userPhotoUrl" 
                             [src]="userPhotoUrl" 
                             [alt]="username"
                             class="w-12 h-12 rounded-full object-cover border border-gray-300 dark:border-gray-700"
                             (error)="showUserPhoto = false; cdr.detectChanges()">
                        
                        <!-- Fallback Avatar (first letter) -->
                        <div *ngIf="!showUserPhoto && (auth.currentUser$ | async)" 
                             class="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg">
                            {{username[0]}}
                        </div>
                        
                        <div>
                            <h3 class="font-semibold" style="color: var(--p-text-color);">{{username}}</h3>
                            <p class="text-sm" style="color: var(--p-text-color-secondary);">Account Settings</p>
                        </div>
                    </div>
                    
                    <!-- Account Menu Items -->
                    <div class="space-y-1">
                        <div *ngFor="let item of accountMenuItems" 
                             class="flex items-center justify-between w-full gap-2 px-4 py-3 rounded-lg transition-colors cursor-pointer" 
                             style="background-color: var(--p-surface-0);"
                             (mouseenter)="onMouseEnter($event)"
                             (mouseleave)="onMouseLeave($event)"
                             (click)="handleMenuItemClick(item, $event)"
                             (contextmenu)="onMenuItemRightClick($event, item)">
                            <div class="flex items-center gap-3">
                                <fa-icon *ngIf="item.icon" [icon]="item.icon" class="w-4 h-4" style="color: var(--p-text-color-secondary);"></fa-icon>
                                <span style="color: var(--p-text-color);">{{item.label}}</span>
                            </div>
                            <div class="flex items-center gap-1">
                                <fa-icon *ngIf="item.url" [icon]="icons.solid.faArrowUpRightFromSquare" class="text-xs" style="color: var(--p-text-color-secondary);"></fa-icon>
                    </div>
                </div>
            </div>
        </div>

             <!-- Theme Picker Content -->
             <div *ngIf="showThemePicker && !showMobileSearch" class="flex-1 overflow-y-auto p-4 space-y-4">
                    <h3 class="text-lg font-semibold" style="color: var(--p-text-color);">Theme Settings</h3>
                    
                    <!-- Theme Selection -->
                    <div class="space-y-3">
                        <div>
                            <label class="font-medium block mb-2" style="color: var(--p-text-color);">Theme</label>
                            <p-select [options]="themeItem?.palettes" 
                                      optionLabel="displayName" 
                                      optionValue="name" 
                                      [(ngModel)]="selectedPalette" 
                                      (onChange)="onPaletteChange($event)" 
                                      placeholder="Select theme" 
                                      class="w-full"></p-select>
                        </div>
                        
                        <div>
                            <label class="font-medium block mb-2" style="color: var(--p-text-color);">Font</label>
                            <p-select [options]="themeItem?.fonts" 
                                      [(ngModel)]="selectedFont" 
                                      (onChange)="onFontChange($event)" 
                                      placeholder="Select font" 
                                      class="w-full"></p-select>
                        </div>
                        
                        <div>
                            <p-button label="Toggle Dark Mode" 
                                      (onClick)="toggleDarkMode()" 
                                      class="w-full" 
                                      [outlined]="true"></p-button>
                        </div>
            </div>
        </div>

             <!-- Regular Submenu Content -->
             <div *ngIf="activeNavItem && (activeNavItem.subItems || activeNavItem.menuItems) && !showMobileSearch && !showAccountMenu && !showThemePicker" class="flex-1 overflow-y-auto p-4">
                <div class="space-y-1">
                    <!-- Handle legacy subItems structure -->
                    <div *ngFor="let subItem of activeNavItem.subItems" class="py-2">
                        <div class="font-semibold text-gray-900 dark:text-gray-100 mb-2">{{subItem.label}}</div>
                        <div *ngFor="let menuItem of subItem.menuItems" class="ml-4 py-1">
                            <div class="font-medium text-gray-700 dark:text-gray-300 mb-1">{{menuItem.label}}</div>
                            <div *ngFor="let item of menuItem.items" class="ml-4 py-1 text-gray-600 dark:text-gray-400">
                                {{item.label}}
                            </div>
                        </div>
                    </div>
                    
                    <!-- Handle modern menuItems structure with full nesting -->
                    <div *ngFor="let menuItem of getMenuItemsFromNavItem(activeNavItem); let i = index" class="mobile-menu-item">
                        <div class="mobile-menu-item-header" 
                             [class.expanded]="isMenuItemExpanded(menuItem)"
                             (click)="menuItem.items && menuItem.items.length > 0 ? toggleMenuItemExpansion(menuItem) : handleMenuItemClick(menuItem, $event)"
                             (contextmenu)="onMenuItemRightClick($event, menuItem)">
                            <div class="flex items-center justify-between w-full">
                                <div class="flex items-center gap-2">
                                    <fa-icon *ngIf="menuItem.icon" [icon]="menuItem.icon" class="text-gray-600 dark:text-gray-400 w-4 h-4"></fa-icon>
                                    <span class="text-gray-700 dark:text-gray-300 font-medium">{{menuItem.label}}</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <fa-icon *ngIf="menuItem.url" [icon]="icons.solid.faArrowUpRightFromSquare" class="text-gray-500 w-3 h-3"></fa-icon>
                                    <fa-icon *ngIf="menuItem.items && menuItem.items.length > 0" 
                                             [icon]="icons.solid.faChevronRight" 
                                             class="text-gray-500 w-3 h-3 transition-transform duration-200"
                                             [class.mobile-chevron-rotate]="isMenuItemExpanded(menuItem)"></fa-icon>
                                </div>
                            </div>
                        </div>
                        
                        <!-- First level submenu -->
                        <div *ngIf="menuItem.items && menuItem.items.length > 0 && isMenuItemExpanded(menuItem)" 
                             class="mobile-submenu">
                            <div *ngFor="let subItem of menuItem.items; let j = index" class="mobile-submenu-item">
                                <div class="mobile-submenu-item-header"
                                     [class.expanded]="isSubMenuItemExpanded(subItem, menuItem.label || '')"
                                     (click)="subItem.items && subItem.items.length > 0 ? toggleSubMenuItemExpansion(subItem, menuItem.label || '') : handleMenuItemClick(subItem, $event)"
                                     (contextmenu)="onMenuItemRightClick($event, subItem)">
                                    <div class="flex items-center justify-between w-full">
                                        <div class="flex items-center gap-2">
                                            <fa-icon *ngIf="subItem.icon" [icon]="subItem.icon" class="text-gray-600 dark:text-gray-400 w-4 h-4"></fa-icon>
                                            <span class="text-gray-600 dark:text-gray-400">{{subItem.label}}</span>
                                        </div>
                                        <div class="flex items-center gap-2">
                                            <fa-icon *ngIf="subItem.url" [icon]="icons.solid.faArrowUpRightFromSquare" class="text-gray-500 w-3 h-3"></fa-icon>
                                            <fa-icon *ngIf="subItem.items && subItem.items.length > 0" 
                                                     [icon]="icons.solid.faChevronRight" 
                                                     class="text-gray-500 w-3 h-3 transition-transform duration-200"
                                                     [class.mobile-chevron-rotate]="isSubMenuItemExpanded(subItem, menuItem.label || '')"></fa-icon>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Second level submenu -->
                                <div *ngIf="subItem.items && subItem.items.length > 0 && isSubMenuItemExpanded(subItem, menuItem.label || '')" 
                                     class="mobile-sub-submenu">
                                    <div *ngFor="let subSubItem of subItem.items" class="mobile-sub-submenu-item"
                                         (click)="handleMenuItemClick(subSubItem, $event)"
                                         (contextmenu)="onMenuItemRightClick($event, subSubItem)">
                                        <div class="flex items-center justify-between w-full">
                                            <div class="flex items-center gap-2">
                                                <fa-icon *ngIf="subSubItem.icon" [icon]="subSubItem.icon" class="text-gray-500 w-4 h-4"></fa-icon>
                                                <span class="text-gray-500">{{subSubItem.label}}</span>
                                            </div>
                                            <fa-icon *ngIf="subSubItem.url" [icon]="icons.solid.faArrowUpRightFromSquare" class="text-gray-400 dark:text-gray-600 w-3 h-3"></fa-icon>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

             <!-- Empty State -->
<!-- Context Menu for Navigation Items -->
<p-contextMenu #contextMenu [model]="contextMenuItems" appendTo="body"></p-contextMenu>
             <div *ngIf="!activeNavItem || (!activeNavItem.subItems && !activeNavItem.menuItems) && !showMobileSearch && !showAccountMenu && !showThemePicker" class="flex-1">
            </div>
        </div>
    </div>
</div>
